const { ccclass, menu } = cc._decorator;

@ccclass
@menu('公共组件/BgAdapter')
export default class BgAdapter extends cc.Component {

    protected onLoad(): void {
        this.node.scale = BgAdapter.getScale()
    }

    static getScale(): number {
        let height = cc.view.getVisibleSize().height
        let maxHeight = cc.view.getDesignResolutionSize().height;
        if (height > maxHeight) {
            return height / maxHeight
        }
        return 1
    }

}